import React from "react";
import moment from 'moment';
import MonthPicker from '../month-picker'
// import DeclarationReportModal from '../declaration-report-modal'
import { getFullMonthFormat } from '../../utils'
import { fetchEmployerDeclaration } from '../../api/employer-declaration/actions'


class EmployerDeclarations extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            mrange: { from: { year: moment.utc().year(), month: 1 }, to: { year: moment.utc().year(), month: moment.utc().month() } },
        }

        this.fetchEmployerDeclarations = this.fetchEmployerDeclarations.bind(this)
    }

    fetchEmployerDeclarations(e) {
        let employerId = '5305962309'
        let date_from = "2017-01-01";
        let date_to = "2018-12-15"

        let mrange = this.state.mrange;

        let dateFrom = mrange.from.year + '-' + getFullMonthFormat(mrange.from.month) + '-01';
        let dateTo = mrange.to.year + '-' + getFullMonthFormat(mrange.to.month) + '-01';

        this.props.dispatch(fetchEmployerDeclaration(employerId, date_from, date_to));
    }

    updateRange(value) {
        this.setState({
            mrange: value
        })
    }

    updateFrom(value) {
        let state = { ...this.state }
        state.mrange.from = value
        this.setState(state)
    }

    updateTo(value) {
        let state = { ...this.state }
        state.mrange.to = value
        this.setState(state)
    }

    displayEmployerDeclarations() {
        if (this.props.declarations.data && !this.props.declarations.isFetching) {
            let declaration = this.props.declarations.data.Employer.DeclarationList.Declaration;
            return (
                <div className="row">
                    <div className="col">DeclarationId: {declaration.DeclarationId}</div>
                    <div className="col">DeclarationStatusTxt: {declaration.DeclarationStatusTxt}</div>
                    <div className="col">DeclarationTypeTxt: {declaration.DeclarationTypeTxt}</div>
                    <div className="col">PeriodEnd: {declaration.PeriodEnd}</div>
                    <div className="col">PeriodStart: {declaration.PeriodStart}</div>
                </div>
            )
        }
    }

    render() {
        // let employerId = '5305962309'
        return (
            <>
                {
                /* <div className="overview">
                    <button data-toggle="modal" data-target={'#DeclarationReportModal' + employerId}>Yfirlit</button>
                </div>
                <DeclarationReportModal id={"DeclarationReportModal" + employerId} declarationType="employer" id={employerId} dispatch={this.props.dispatch}/> */}

                <MonthPicker mrange={this.state.mrange} updateRange={this.updateRange.bind(this)} updateFrom={this.updateFrom.bind(this)} updateTo={this.updateTo.bind(this)} />
                <button onClick={this.fetchEmployerDeclarations}>Sækja yfirlit</button>
                {this.displayEmployerDeclarations()}

            </>
        )
    }
}

export default EmployerDeclarations